import React from 'react'

const WebApps = () => {
  return (
    <div>WebApps</div>
  )
}

export default WebApps